<template>
  <div class="heim-select">
    <label>
      <span class="label">{{label}}</span>
      <select
        class="paper-input"
        :name="name"
        v-model="selected"
        @change="$emit('input', $event.target.value)"
        :required="required"
      >
        <option value=""></option>
        <option
          v-for="(item, idx) in data"
          :value="String(item[valueKey]).toLowerCase()"
          :key="'select-'+idx"
          :selected="item[valueKey] == value ? true: false"
        >{{$t(item[labelKey])}}</option>
      </select>
    </label>
  </div>
</template>

<script>
export default {
  name: "heim-select2",
  props: {
    label: String,
    name: String,
    data: {
      type: Array
    },
    labelKey: String,
    valueKey: String,
    required: String,
    value: {
      default: null
    }
  },
  data() {
    return {
      selected: this.value
    };
  },
  watch: {
    value() {
      this.selected = this.value;
    }
  }
};
</script>

<style scoped>
.label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}
select.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
select.paper-input:hover,
select.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
select.paper-input.password {
  padding-right: 32px;
}

/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .heim-select {
    max-width: 32em;
  }
}
</style>
